"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOURCE_SORT_ORDER = exports.CONTENT_TYPE_SORT_ORDER = void 0;
var CONTENT_TYPE_SORT_ORDER = ['question', 'discussion', 'article', 'ideation', 'productUpdate', 'event'];
exports.CONTENT_TYPE_SORT_ORDER = CONTENT_TYPE_SORT_ORDER;
var SOURCE_SORT_ORDER = ['community', 'knowledge_base', 'docs'];
exports.SOURCE_SORT_ORDER = SOURCE_SORT_ORDER;